import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import adminsReducer from "../features/admins/adminsSlice";
import categoriesReducer from "../features/categories/categorySlice";
import customerReducer from "../features/customers/customerSlice";
import externalLogsReducer from '../features/externalLogs/externalLogsSlice';
import gatewayOrderReducer from '../features/gatewayOrders/gatewayOrderSlice';
import grievanceReducer from '../features/grievances/grievanceSlice';
import schemeBucketReducer from '../features/schemeBuckets/schemeBucketSlice';
import schemeReducer from '../features/schemes/schemeSlice';
import preApprovalReducer from '../features/preApprovalLogs/preApprovalSlice';
import merchantReducer from '../features/merchants/merchantSlice';
import partnerBrandReducer from '../features/partnerBrands/partnerBrandSlice';
import productReducer from '../features/products/productSlice';
import dashboardstatsReducer from '../features/dashboard/dashboardSlice';
import orderReducer from '../features/orders/orderSlice';
import kycMerchantReducer from '../features/kycPendingMerchants/merchantKYCSlice'
import merchantApprovalReducer from '../features/merchantApproval/merchantApprovalSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    admins: adminsReducer, // ✅ must register here
    categories: categoriesReducer, // ✅ add categories slice
    customers: customerReducer, // ✅ add customers slice
    externalLogs: externalLogsReducer, // ✅ add external logs slice
    gatewayOrders: gatewayOrderReducer, // ✅ add gateway orders slice
    grievances: grievanceReducer, // ✅ add grievances slice
    schemeBucket: schemeBucketReducer, // ✅ add scheme buckets slice
    scheme: schemeReducer, // ✅ add schemes slice
    preApproval: preApprovalReducer, // ✅ add pre-approval logs slice
    merchant: merchantReducer, // ✅ add merchants slice
    merchantKYC : kycMerchantReducer,
    partnerBrand: partnerBrandReducer, // ✅ add partner brands slice
    products: productReducer, // ✅ add products slice
    dashboard: dashboardstatsReducer, // ✅ add dashboard stats slice
    orders: orderReducer, // ✅ add orders slice
    merchantApproval: merchantApprovalReducer,
  },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
